<div class="system-form-wrapper">
  @if (templateJson) {
    <app-preview-template #templateComRef [templateData]="templateJson" [isPreview]="false"
      [templateType]="templateType" [recordId]="recordId"
      [templateName]=""
      [isSystemForm]="true">
    </app-preview-template>
  } @else {
    <div class="text-gray-500 p-4 text-center">No template available</div>
  }

</div>
